
import { Component, Prop, Vue } from 'vue-property-decorator'

import videojs from 'video.js'
import 'video.js/dist/video-js.css'

@Component({
})
export default class BacVideoPlayer extends Vue {
  @Prop({ default: {} }) options!: any

  player: videojs.Player|null = null

  mounted () {
    this.player = videojs(this.$refs.videoPlayer as HTMLElement, this.options)
  }

  beforeDestroy () {
    if (this.player) {
      this.player.dispose()
    }
  }
}
